import loadable from '@loadable/component';

export const OrgDashboardRepostEventPageLoadable = loadable(
  () => import('./OrgDashboardRepostEventPage'),
  {
    resolveComponent: (module) => module.OrgDashboardRepostEventPage,
  },
);
